// First-bytes sniff for the warn-but-allow corrupt-file check (spec
// 2026-07-14 §4). Matches common audio/container signatures; anything
// unmatched gets a soft warning, never a hard block — exotic-but-legitimate
// formats must survive, and Soniox stays the authority on decodability.
// Born from meeting eff26ca3: a 317-byte JSON metadata stub wearing an
// .mp3 name sailed through to Soniox and failed there.

const ascii = (s: string) => [...s].map((c) => c.charCodeAt(0));

const SIGNATURES: Array<{ bytes: number[]; offset?: number }> = [
  { bytes: ascii("ID3") },                                    // mp3 with ID3 tag
  { bytes: ascii("RIFF") },                                   // wav
  { bytes: ascii("OggS") },                                   // ogg / opus
  { bytes: ascii("fLaC") },                                   // flac
  { bytes: ascii("ftyp"), offset: 4 },                        // m4a / mp4 / mov
  { bytes: [0x1a, 0x45, 0xdf, 0xa3] },                        // webm / mka (EBML)
  { bytes: [0x30, 0x26, 0xb2, 0x75, 0x8e, 0x66, 0xcf, 0x11] }, // wma (ASF GUID)
  { bytes: ascii("#!AMR") },                                  // amr
];

export function looksLikeAudio(bytes: Uint8Array): boolean {
  // MPEG frame sync (raw mp3 / aac ADTS): 11 set bits across bytes 0-1.
  if (bytes.length >= 2 && bytes[0] === 0xff && (bytes[1] & 0xe0) === 0xe0) return true;
  return SIGNATURES.some(({ bytes: sig, offset = 0 }) =>
    bytes.length >= offset + sig.length && sig.every((b, i) => bytes[offset + i] === b),
  );
}

/** Read the file's first 16 bytes in the browser and sniff them. */
export async function fileLooksLikeAudio(file: File): Promise<boolean> {
  const bytes = new Uint8Array(await file.slice(0, 16).arrayBuffer());
  return looksLikeAudio(bytes);
}
